var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo, useState } from "react";
import { ModalFooter, SlideInModalPortal, } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { useTranslation } from "react-i18next";
import { PAGE_CLOSE_MODAL, PAGE_FUNCTION, PAGE_NAME, } from "../../const/analytics";
import MainContext from "../Context";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import AccountDetails from "../AccountDetails/AccountDetails";
import WaivedInterestTooltip from "../WaivedInterestTooltip/WaivedInterestTooltip";
import DetailsModalContext from "../../DetailsModalContext";
export var accountDetailsModalId = "account-details-modal";
var AccountDetailsModal = function (_a) {
    var handleClose = _a.handleClose, isModalOpen = _a.isModalOpen, containerId = _a.containerId;
    var triggerAnalyticsEvent = useContext(MainContext).triggerAnalyticsEvent;
    var t = useTranslation().t;
    // we have to remove isWaivedInterestTooltip in future story
    var _b = useState(false), isWaivedInterestTooltip = _b[0], setIsWaivedInterestTooltip = _b[1];
    var closeTooltipModal = function () {
        setIsWaivedInterestTooltip(false);
    };
    var handleCloseWithAnalytics = function () {
        // create analytics request when the modal is closed
        if (triggerAnalyticsEvent) {
            triggerAnalyticsEvent({
                pageFunction: PAGE_FUNCTION,
                pageSubFunction: PAGE_CLOSE_MODAL,
                pageName: PAGE_NAME.VIEW,
            });
        }
        if (isWaivedInterestTooltip) {
            closeTooltipModal();
        }
        handleClose();
    };
    var modalFooter = isWaivedInterestTooltip ? (_jsx(ModalFooter, { handlePrimaryButton: closeTooltipModal, primaryText: t("modal.footer.backButton"), dataPrimaryType: "account details", dataPrimaryObject: "button", dataPrimaryReason: "close" })) : (_jsx(ModalFooter, { handlePrimaryButton: handleCloseWithAnalytics, primaryText: t("modal.footer.closeButton"), dataPrimaryType: "account details", dataPrimaryObject: "button", dataPrimaryReason: "close" }));
    var contextValue = useMemo(function () { return ({
        isWaivedInterestTooltip: isWaivedInterestTooltip,
        setIsWaivedInterestTooltip: setIsWaivedInterestTooltip,
    }); }, [isWaivedInterestTooltip, setIsWaivedInterestTooltip]);
    return (_jsx(SlideInModalPortal, __assign({ ariaLabel: "Account Details", containerId: containerId, id: accountDetailsModalId, isOpen: isModalOpen, escapeModalHandler: handleCloseWithAnalytics, footer: modalFooter }, { children: _jsx(DetailsModalContext.Provider, __assign({ value: contextValue }, { children: _jsx(ErrorBoundary, { children: isWaivedInterestTooltip ? (_jsx(WaivedInterestTooltip, { handleCloseWithAnalytics: handleCloseWithAnalytics })) : (_jsx(AccountDetails, { handleCloseWithAnalytics: handleCloseWithAnalytics })) }) })) })));
};
export default AccountDetailsModal;
//# sourceMappingURL=AccountDetailsModal.js.map